"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLimitConfigEvaluator = exports.getConcentrationConfigValueType = exports.checkLimitConfigErrors = exports.createAvailableFormulaFieldsProposals = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
/**
 * Generates list of helpful fields available to a limit config formula CompletionItems for Monaco Editor
 */
const proposals = [
    {
        label: 'loanTapeMetadata.reportingDate',
        documentation: 'Loan tape reporting date',
        insertText: 'loanTapeMetadata.reportingDate',
    },
];
const createAvailableFormulaFieldsProposals = () => proposals;
exports.createAvailableFormulaFieldsProposals = createAvailableFormulaFieldsProposals;
const checkLimitConfigErrors = ({ concentrationLimitConfig, }) => {
    const availableVariables = new Set(proposals.map((proposal) => proposal.label));
    if (concentrationLimitConfig.valueConfig.type === 'formula') {
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(concentrationLimitConfig.valueConfig.limit, availableVariables);
        if (formulaErrors.errorMessages.length === 0) {
            return [];
        }
        return [
            {
                reason: concentrationLimitConfig.propertyKey,
                ...formulaErrors,
            },
        ];
    }
    return [];
};
exports.checkLimitConfigErrors = checkLimitConfigErrors;
// returns `valueType` for given concentration limit config.
// the valueType is currently specified in config.
// soon it will be inferred. For now its inferred only
// for formula configs.
const getConcentrationConfigValueType = (concentrationLimitConfig) => {
    if (!concentrationLimitConfig) {
        return 'number';
    }
    return concentrationLimitConfig.valueConfig.valueType;
};
exports.getConcentrationConfigValueType = getConcentrationConfigValueType;
const createLimitConfigEvaluator = (concentrateLimitConfig, f1EngineMode) => {
    const formulaString = concentrateLimitConfig.valueConfig.limit;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString], f1EngineMode);
    const evaluate = (loanTapeMetadata) => {
        // we should try to remove this use of loanTapeMetadata here
        // loanTapeMetadata should be limited into intermediate variable
        // such that we don't have to worry about Partial<LoanTapeMetadata, 'reportingDate'>
        // here, as this usage it a little confusing, since loanTapeMetadata is not guaranteed to
        // contain all the expected properties like it would in intermediate variables
        const formulaInputs = {
            loanTapeMetadata,
        };
        formulaEngine.setVariables(formulaInputs, { flatten: true });
        const limit = formulaEngine.evaluateNumber(formulaString);
        const valueType = (0, exports.getConcentrationConfigValueType)(concentrateLimitConfig);
        return valueType === 'currency'
            ? {
                type: 'number',
                limit,
                valueType,
                currency: finley_types_1.Bank.Currency.USD,
            }
            : {
                type: 'number',
                limit,
                valueType,
            };
    };
    return {
        evaluate,
    };
};
exports.createLimitConfigEvaluator = createLimitConfigEvaluator;
//# sourceMappingURL=concentrationLimitValueEvaluator.js.map